import React from 'react'
import './LeftBar.css'
import FacebookIcon from '@material-ui/icons/Facebook';
import InstagramIcon from '@material-ui/icons/Instagram';
import GitHubIcon from '@material-ui/icons/GitHub';
import LinkedInIcon from '@material-ui/icons/LinkedIn';

function LeftBar() {
    return (
        <div className="leftBar">
            <div className="vericalLineLeftUp"></div>
            <a href="https://www.facebook.com/oussama.berarma.12/" target="_blank">
            <FacebookIcon />
            </a>
            <a href="https://www.instagram.com/oussama_berarma/" target="_blank">
            <InstagramIcon />
            </a>
            <a href="https://github.com/ouss1919" target="_blank">
            <GitHubIcon />
            </a>
            <a href="https://www.linkedin.com/in/oussama-berarma/" target="_blank">
            <LinkedInIcon />
            </a>
            <div className="vericalLineLeftDown"></div>

        </div>
    )
}

export default LeftBar
